import { Button, Skeleton, useDisclosure } from "@chakra-ui/react";
import React, { useCallback } from "react";
import { GenericError } from "src/components/Feedback/GenericError";
import { RemoteDataView } from "src/components/Layout/RemoteDataView";
import { useFlags } from "src/components/Providers/FeatureFlagProvider";
import { useUserPermissions } from "src/hooks/useUserPermissions";
import * as RD from "src/types/remoteData";
import { CreateFormTemplateDialog } from "./CreateFormTemplateDialog";
import { CreateFromScratchDialog } from "./CreateFromScratchDialog";

export const CreateNewFormTemplateButton: React.FC = () => {
  const {
    isOpen: createFormTemplateIsOpen,
    onOpen: onOpenCreateFormTemplate,
    onClose: onCloseCreateFormTemplate,
  } = useDisclosure();

  const {
    isOpen: createFromScratchIsOpen,
    onOpen: onOpenCreateFromScratch,
    onClose: onCloseCreateFromScratch,
  } = useDisclosure();

  const handleCreateFromScratch = useCallback(() => {
    onOpenCreateFromScratch();
    onCloseCreateFormTemplate();
  }, [onCloseCreateFormTemplate, onOpenCreateFromScratch]);

  const flags = useFlags(["form-template-content-export-import"]);

  const handleCancelCreateFromScratch = useCallback(() => {
    if (flags["form-template-content-export-import"].enabled) {
      onCloseCreateFromScratch();
    } else {
      onOpenCreateFormTemplate();
      onCloseCreateFromScratch();
    }
  }, [flags, onCloseCreateFromScratch, onOpenCreateFormTemplate]);

  const createNewFormTemplateHandler = useCallback(() => {
    if (flags["form-template-content-export-import"].enabled) {
      onOpenCreateFromScratch();
    } else {
      onOpenCreateFormTemplate();
    }
  }, [flags, onOpenCreateFormTemplate, onOpenCreateFromScratch]);

  const permissionsRD = RD.fromUserPermissions(useUserPermissions());

  const loading = <Skeleton height="2.5rem" width="10rem" />;

  return (
    <RemoteDataView
      remoteData={permissionsRD}
      loading={loading}
      error={(error) => <GenericError error={error} variant="inline" />}
    >
      {(permissions) => {
        if (!permissions.hasOne("form_template:create")) {
          return null;
        }
        return (
          <>
            <Button onClick={createNewFormTemplateHandler}>
              Create new form
            </Button>
            <CreateFormTemplateDialog
              isOpen={createFormTemplateIsOpen}
              onCancel={onCloseCreateFormTemplate}
              onCreateFromScratch={handleCreateFromScratch}
            />
            <CreateFromScratchDialog
              isOpen={createFromScratchIsOpen}
              onCancel={handleCancelCreateFromScratch}
            />
          </>
        );
      }}
    </RemoteDataView>
  );
};
